import { useState } from 'react';
import { ApplicationSubmit } from './PersonalDataApplicationSubmit/ApplicationSubmit/ApplicationSubmit.tsx';
import { ApplicationRevoke } from './PersonalDataApplicationRevoke/ApplicationRevoke/ApplicationRevoke.tsx';
import { ProcessClientVerificationSubmit } from './ProcessClientVerification/ProcessClientVerificationSubmit';
import { ProcessClientVerificationRevoke } from './ProcessClientVerification/ProcessClientVerificationRevoke.tsx';
import FullPageLoader from '~/components/FullPageLoader/FullPageLoader.tsx';

interface PersonalDataApplicationProps {
  isRevoke?: boolean;
}

export default function PersonalDataApplication({
  isRevoke = false,
}: PersonalDataApplicationProps) {
  const [isVerified, setIsVerified] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  return (
    <>
      {isLoading && <FullPageLoader />}
      {!isVerified &&
        (isRevoke ? (
          <ProcessClientVerificationRevoke
            onSuccess={() => setIsVerified(true)}
            isLoading={setIsLoading}
          />
        ) : (
          <ProcessClientVerificationSubmit
            onSuccess={() => setIsVerified(true)}
            isLoading={setIsLoading}
          />
        ))}
      {isVerified && (isRevoke ? <ApplicationRevoke /> : <ApplicationSubmit />)}
    </>
  );
}
